import { Configuration } from "../models/Configuration";

export const EAKTYWNI_TERMS_URL = "https://eaktywni.pl/regulamin/";

export const TTPAY_TERMS_URL = "https://eaktywni.pl/regulamin-ttpay/";

export function getEAktywniTermsUrl(configuration?: Pick<Configuration, "showTermsAsTTPay">): string {
  return configuration?.showTermsAsTTPay ? TTPAY_TERMS_URL : EAKTYWNI_TERMS_URL;
}

